import React, { useCallback, useEffect, useState } from 'react'
import AddCircle from '../icons/AddCircle'
import { AppDispatch, RootState } from '../../redux-stores/store'
import { useDispatch } from 'react-redux'
import { fetchAddressesThunk } from '../../redux-stores/slices/addressSlice'
import { useSelector } from 'react-redux'
import HomeIcon from '../icons/HomeIcon'
import WorkIcon from '../icons/WorkIcon'
import { SavedAddress } from '../../types/address'

interface AddressListProps {
    onAddNew: () => void
    onSelection?: (savedAddress: SavedAddress) => void
    selectedAddressUUID?: string | null
}
const AddressList: React.FC<AddressListProps> = ({ onAddNew, onSelection, selectedAddressUUID }) => {

    const dispatch: AppDispatch = useDispatch();

    const addressBook = useSelector((state: RootState) => state.addressBook.list);

    const [selectedAddress, setSelectedAddress] = useState<SavedAddress|null>(null);

    const fetchAddressBook = useCallback(() => {
        dispatch(fetchAddressesThunk({}));
    }, [dispatch])

    useEffect(() => {
        fetchAddressBook();
    }, [dispatch, fetchAddressBook])

    const handleClick = (address: SavedAddress) => {
        setSelectedAddress(address);
    }

    useEffect(() => {
        if (selectedAddressUUID) {
            const selected = addressBook.find(address => address.uuid === selectedAddressUUID);
            if (selected) {
                setSelectedAddress(selected);
            }
        }
    }, [selectedAddressUUID, addressBook])

    useEffect(() => {
        if(onSelection && selectedAddress) onSelection(selectedAddress)
    }, [selectedAddress])


    return (
        <div className="addresses overflow-scroll">
            <div className="action-btns">
                <div className="address-action-btn" onClick={onAddNew}>
                    <AddCircle />
                    Add New Address
                </div>
            </div>
            <div className="location-list">
                <span className="location-list-title">Saved Address</span>
                {
                    addressBook.map((address, i) => {
                        return (
                            <div className="location-list-item cursor-pointer" key={i} onClick={() => handleClick(address)} >
                                <div className="location-list-item-top">
                                    <div className="gig-selection-checkbox-wrapper">
                                        <input
                                            type="checkbox"
                                            className="form-check-input gig-selection-check-input radio-check"
                                            checked={selectedAddress?.uuid === address.uuid}
                                            onChange={() => setSelectedAddress(address)}
                                        />
                                    </div>
                                    {address.name === 'Home' ? <HomeIcon /> : (address.name === 'Work' ? <WorkIcon /> : "")}
                                    <span className="location-list-item-title">
                                        {address.name}
                                    </span>
                                </div>
                                <span className="location-list-item-address">
                                    {address.premise ? `${address.premise},` :''} {address.sublocality ? `${address.sublocality},` : ''} {address.city ? `${address.city},` : ''} {address.region ? `${address.region},` : ''} {address.pincode}
                                </span>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default AddressList